/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Grower_File_Detach_SuccessInputs */

const vi_toast_grower_file_detach_success = /** @type {(inputs: Toast_Grower_File_Detach_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gỡ giấy tờ`)
};

/**

* @param {Toast_Grower_File_Detach_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_grower_file_detach_success = /** @type {((inputs?: Toast_Grower_File_Detach_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Grower_File_Detach_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_grower_file_detach_success(inputs)
});